import { render, staticRenderFns } from "./PdDtlLayout.vue?vue&type=template&id=3493d194&"
import script from "./PdDtlLayout.vue?vue&type=script&lang=js&"
export * from "./PdDtlLayout.vue?vue&type=script&lang=js&"
import style0 from "./PdDtlLayout.vue?vue&type=style&index=0&id=3493d194&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports